export default __webpack_public_path__ + "static/media/kubernetes-dashboard.e512a4d2.png";